module.exports = __webpack_public_path__ + "img/outdoor_b.ea05fe51.svg";